/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Отображение вкладок в корзине
   */
  app.CartTabsView = app.TabsBaseItemView.extend({
    el: '.sl-tabs',
    selectedTabId: 0,
    inactiveTabInnerClass: '',
    template: '#cart-tabs-template',

    run: function (options) {
      if (!this.model) {
        return;
      }
      if(options && options.settlement){
        this.settlement = options.settlement;
      }
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.listenTo(this.model, 'sync', this.render);
      this.listenTo(Backbone, 'DeleteItemFromCart', this.render);
      this.listenTo(this.settlement, 'change', this.render);
    },

    /**
     * Сделать таб активным
     * @param $tab jQueryObject
     */
    selectTab: function ($tab) {
      if (!app.isMobile) {
        app.TabsBaseItemView.prototype.selectTab.call(this, $tab);
      }

      var code = $tab.data().code;
      this.selectedTabId = $tab.data().tabId;
      if (code) {
        this.model.queryParams.group = code;
        this.model.state.currentPage = 1;
        app.preloader.render();
        this.model.fetch();
      }
    },

    render: function () {
      var groups = this.model.getGroups();
      // Если есть товары с удаленного и с локального склада
      // и доступен заказ товаров партнеров
      if (groups && this.settlement.isRemoteStoreEnabled()){
        var templateData = {
          groups: this.model.cartInfo.groups,
          selectedTabId: this.selectedTabId
        };
        this.$el.html(this.template(templateData));
        app.preloader.remove();
      } else {
        this.$el.html('');
        this.resetGroup();
      }
      if (!app.isMobile) {
        Backbone.trigger('cart-aside:need-update-margin');
      }
    },

    /**
     * Сбросить параметр группы, выбранный таб и перезагрузить коллекцию
     */
    resetGroup: function () {
      if (this.model.queryParams.group) {
        delete this.model.queryParams.group;
        this.selectedTabId = 0;
        this.model.state.currentPage = 1;
        app.preloader.render();
        this.model.fetch();
      }
    },
  });
})(jQuery);

}.call(window));